import {
    SET_PROJECT,
    SET_PROJECT_ELEMENTS,
    SET_SELECTED_PROJECT_ELEMENT_ID,
    SET_SELECTED_MESH_ID,
    SET_SELECTED_MESH,
    SET_IS_OPTIMIZED_VIEW,
    SET_SELECTED_REFERENCE
} from '../actions/Project';

const initialState = {
    elements: null,
    selectedProject: null,
    selectedProjectElementId: null,
    selectedMeshId: null,
    selectedMesh: null,
    projectIsLoading: false,
    sideBarIsOpened: true,
    usdzUploadProgress: null,
    usdzUrl: null,
    regenerateUsdz: false,
    isOptimizedView: true,
    selectedReference: null
};
  
export default function ProjectReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PROJECT: {
            return {
                ...state,
                selectedProject: action.selectedProject,
            };
        }

        case SET_PROJECT_ELEMENTS: {
            return {
                ...state,
                elements: action.elements,
            };
        }

        case SET_SELECTED_PROJECT_ELEMENT_ID: {
            return {
                ...state,
                selectedProjectElementId: action.selectedProjectElementId,
            };
        }

        case SET_SELECTED_MESH_ID: {
            return {
                ...state,
                selectedMeshId: action.selectedMeshId,
            };
        }

        case SET_SELECTED_MESH: {
            return {
                ...state,
                selectedMesh: action.selectedMesh,
            };
        }

        case SET_IS_OPTIMIZED_VIEW: {
            return {
                ...state,
                isOptimizedView: action.isOptimizedView,
            };
        }

        case "SET_PROJECT_IS_LOADING": {
            return {
                ...state,
                projectIsLoading: action.projectIsLoading,
            };
        }

        case "SET_SIDEBAR_IS_OPENED": {
            return {
                ...state,
                sideBarIsOpened: action.sideBarIsOpened,
            };
        }

        case "SET_USDZ_UPLOAD_PROGRESS" : {
            return {
                ...state,
                usdzUploadProgress: action.usdzUploadProgress
            }
        }

        case "SET_USDZ_URL" : {
            return {
                ...state,
                usdzUrl: action.usdzUrl
            }
        }

        case "SET_REGENERATE_USDZ" : {
            return {
                ...state,
                regenerateUsdz: action.regenerateUsdz
            }
        }

	case SET_SELECTED_REFERENCE: {
            return {
                ...state,
                selectedReference: action.selectedReference
            }
        }

        default: {
            return state;
        }
    }
}
